
import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { StoresStore } from "@/store/modules/Warehouse/Warehouse";
import { FormMix } from "@/UI/mixins/FormMix";
import { mixins } from "vue-class-component";
import { StoreMix } from "@/UI/mixins/Store/StoreMix";
import { ProductsMix } from "@/UI/mixins/Store/ProductsMix";
import { FormRules, SaleProductData, SaleProductFormData, } from "@/form/Warehouse/Operations/SaleProductFormData";
import { FormLayoutMix } from "@/UI/mixins/Layouts/Form";
import { OperationsMix } from "@/UI/mixins/Store/OperationsMix";
import { PaginationMix } from "@/UI/mixins/PaginationMix";
import moment from "moment";
import { CancelMix } from "@/UI/pages/Stores/Mixins/CancelMix";
import { ProductsStockMix } from "@/UI/mixins/Store/ProductsStockMix";
import { getStudioId } from "@/UI/lib/state";
import { ProductsStockStore } from "@/store/modules/Warehouse/ProductsStock";
import { OperationsStore } from "@/store/modules/Warehouse/Operations";
import { DataEntity, Operations, ProductsOperationEntity } from "@/entity/warehouse/Operations/Operations.types";
import { DataEntityStock, ProductsStock } from "@/entity/warehouse/Products/ProductsStock.types";
import { ScrollData, SearchData } from "@/UI/Decorators/decorator";
import { HideOnScrollMix } from "@/UI/mixins/Calendar/HideOnScrollMix";
import ModalWrapper from "@/UI/components/common/ModalWrapper.vue";

@Component({
    components: {
        ModalWrapper,
        BaseDataForm
    },
    methods: { moment },
})

export default class WriteOff extends mixins(
    FormMix,
    StoreMix,
    ProductsMix,
    OperationsMix,
    FormLayoutMix,
    PaginationMix,
    CancelMix,
    HideOnScrollMix,
    ProductsStockMix,
) {
    @Prop() forms!: SaleProductFormData
    showStockProducts = false;
    rules = FormRules;
    formReady = false;
    stockProducts: ProductsStock | null = null;
    preloadedProducts: DataEntityStock[] = [];
    t_mod: boolean = false
    tree_keys = [];
    handleModal(): void {
        this.showStockProducts = false;
    }
    public addProductsFromList(): void {
        this.showStockProducts = true;
    }

    @SearchData
    hSearch(source: string, value: {}) { }
    handleSearch(value: string) {
        this.hSearch('productsStock', { name: value, store_id: this.forms.store_id })
    }
    @ScrollData
    hScroll(source: string, value: {}) { }
    handleScroll() {
        this.hScroll('productsStock', { store_id: this.forms.store_id })
    }

    public deleteProduct(index: number): void {
        this.forms.deleteProduct(index);
    }
    public addProduct(): void {
        const product = new SaleProductData();
        this.forms.addProduct(product);
    }

    datee(value: string) {
        if (this.forms.date) {
            return moment(value, 'DD.MM.YYYY')
        } else {
            this.forms.date = ''; // если ставить просто '', то пикер удаляется из DOM
        }
    }
    timee(value: string) {
        if (this.forms.time) {
            if (this.forms.time.length > 5) {
                return moment(value.substr(11), 'HH:mm')
            } else {
                return moment(value, 'HH:mm')
            }
        } else {
            this.forms.time = ''; // если ставить просто '', то пикер удаляется из DOM
        }
    }

    changeDate(date: any): void {
        this.forms.date = date ? date.format('DD.MM.YYYY') : moment(); // если ставить просто '', то пикер удаляется из DOM
    }
    changeTime(time: any) {
        this.forms.time = time ? time.format('HH:mm') : moment(); // если ставить просто '', то пикер удаляется из DOM
    }

    selectAndAddProduct() {
        this.tree_keys.forEach((i: any, index: any) => {
            let product = new SaleProductData();
            let productStoreProduct: any = this.productsStocks?.data.find((item: any) => {
                return item.id === i
            })
            product.id = productStoreProduct?.nomenclature?.id
            product.price = productStoreProduct?.nomenclature?.cost_price
            product.total = productStoreProduct?.nomenclature?.cost_price.replace(/\s/g, '')
            this.forms.addProduct(product);
        });
        this.showStockProducts = false;
    }

    async selectProduct(index: any) {
        console.log("selcetProd")
        let price = ProductsStockStore.items?.data.find((item: any) => {
            return item.product_nomenclature_id === this.forms.products![index].id
        })?.cost_price_formated as any
        this.forms.products![index].total = this.forms.products![index].price = price.replace(/\s/g, '')
    }

    onCheck(checkedKeys: any): void {
        console.log("onCheck", checkedKeys)
        this.tree_keys = checkedKeys;
    }
    calculate(index: any) {
        const sum: any = Number(this.forms.products![index].price) * Number(this.forms.products![index].quantity)
        this.forms.products![index].total = sum - Number(this.forms.products![index].quantity) * Number(this.forms.products![index].price) * Number(this.forms.products![index].discount) / 100
    }

    get finalSum() {
        let sum = 0
        this.forms.products!.forEach(item => {
            sum += Number(item.total as any)
        })
        if (this.t_mod === true) {
            sum = this.operations?.data![0].total_sum as any
            this.t_mod = false
        }
        return sum
    }

    async storeChange(): Promise<void> {
        this.forms.products = []
        let filter = {
            store_id: this.forms.store_id
        }
        await this.fetchProductStock(filter)
    }

    async fetchProductStock(filter: any) {
        await ProductsStockStore.fetchAll({ filter: filter })
    }

    async getData(): Promise<void> {
        if (this.$router.currentRoute.params["id"] !== "0") {
            await OperationsStore.fetchAll({ filter: { id: this.$router.currentRoute.params["id"] } });
            this.t_mod = true
            for (let i of (this.operations?.data as any)) {
                this.forms.id = i.id;
                this.forms.storage_operation_type_id = i.storage_operation_type_id;
                this.forms.date = i.date
                this.forms.comment = i.comment
                this.forms.time = i.date.substr(11, 5)
                this.forms.store_id = i.store_id
                this.forms.products = [];
                i.products.forEach((x: any, index: number) => {
                    this.forms.products.push(x)
                    this.forms.products[index].id = x.product_id
                })
            }
            await this.fetchProductStock({ store_id: this.forms.store_id })
        }
    }

    async created(): Promise<void> {
        this.tableLoad = false;
        if (!this.formReady) {
            try {
                await this.getData()
                await StoresStore.fetchAll({ limit: this.AppPageParams.pageSize, filter: { salon_id: getStudioId(this) } });
            } catch (e) {
                console.log(e);
            } finally {
                this.formReady = true;
            }
        }

        if (this.$route.params.id === '0') {
            this.forms.date = moment().format('DD.MM.YYYY');
            this.forms.time = moment().format('HH:mm');
        }
    }
}
